"use strict";

exports.__esModule = true;
exports.MEMBER_DRAFTS_ID = exports.MEMBERS_PAGE_ID = exports.BLOG_WIDGET_ID = exports.BLOG_POST_PAGE_ID = exports.BLOG_PAGE_ID = void 0;
var BLOG_PAGE_ID = 'blog';
exports.BLOG_PAGE_ID = BLOG_PAGE_ID;
var BLOG_POST_PAGE_ID = 'post';
exports.BLOG_POST_PAGE_ID = BLOG_POST_PAGE_ID;
var BLOG_WIDGET_ID = 'blog_header_widget';
exports.BLOG_WIDGET_ID = BLOG_WIDGET_ID;
var MEMBERS_PAGE_ID = 'members';
exports.MEMBERS_PAGE_ID = MEMBERS_PAGE_ID;
var MEMBER_DRAFTS_ID = 'member-drafts-page';
exports.MEMBER_DRAFTS_ID = MEMBER_DRAFTS_ID;